module.exports = __webpack_public_path__ + "resources/img/logo_partner_commerce_6.71593d6a80f664600947c84986a31f7b.png";